// React
import React from "react";

// Images
import logo_crecer from "../assets/images/logoCrecer.png";
import logo_primero_lee from "../assets/images/logoPrimeroLee.png";

export default function Pie() {
  return (
    <div className="row justify-content-around align-items-center Pie">
      <img src={logo_crecer}></img>
      <a href="https://fundacioncrecer.net/">
        <p>primerolee.cl</p>
      </a>
      <img src={logo_primero_lee}></img>
    </div>
  );
}
